import { Outlet, useLocation } from "react-router-dom";

import styles from "./styles.module.scss";
import PeopleBackground from "../../components/PeopleBackground";
import AuthCheck from "../../components/AuthCheck";
import { useClassNames } from "../../shared/hooks";

const PublicRouteWrapper = () => {
  const location = useLocation();
  const classNames = useClassNames([
    styles.PublicRouteWrapper,
    location.pathname !== "/"
      ? styles["PublicRouteWrapper-peopleBackground"]
      : "",
  ]);

  return (
    <AuthCheck>
      <main className={classNames}>
        <Outlet />
        {location.pathname !== "/" && <PeopleBackground />}
      </main>
    </AuthCheck>
  );
};

export default PublicRouteWrapper;
